import { DistributionModels } from '../resources/base/models/distributionModel';

/**
 * Data model of values held by Quotation page form.
 */
export interface QuotationFormData {
  contractMileage: number;
  annualMileage: number;
  financedAmount: number;
  recommendedRV: number;
  overruledRV: number;
  overruledRVNetAmount: number;
  overruledRVPercentage: number;
  contractRVPercentage: number;
  contractRVAmount: number;
  firstInstallmentIsIncreased: boolean;
  firstInstallmentAmount: number;
  firstInstallmentAmountPercentage: number;
  pricingId: string;
  numberOfMonthlyInstallments: number;
  downPaymentAmount: number;
  downPaymentAmountPercentage: number;
  firstInstallmentWithDownPaymentAmount: number;
  firstInstallmentWithDownPaymentPercentage: number;
  /**
   * - Non-interactive. Do not expose to UI.
   */
  _minDealerDiscountAmount: number;
  /**
   * - Non-interactive. Do not expose to UI.
   */
  _minDealerDiscountPercentage: number;
  /*  */
  financialProduct: string;
  duration: number | undefined;
  excessMileagePriceAmount: number;
  vehicleTotalCost: number;
  totalDiscountAmount: number;
  totalDiscountPercentage: number;
  milesBonusEcologic: number;
  milesPrimeCee: number;
  milesPricingStrategy: QuoteSchema.Schemas.MilesPricingStrategyEnumType;
  milesPackage?: QuoteSchema.Schemas.MilesPackageEnumType;
  serviceBonus: number;
  eligibility: number;
  dealerEffort: number;
  dealerEffortMax: number;
  totalAmountInsAndServ: string;
  subsequentInstallment: number;
  spreadLeasePrice: number;
  selectedPromotions?: string[];
  deselectedPromotions?: string[];
  preWarehousePriceHT: number;
  transportHT: number;
  priceCatalogueHT: number;
  grayCardHT: number;
  preWarehousePriceTTC: number;
  transportTTC: number;
  priceCatalogueTTC: number;
  grayCardTTC: number;
  optionsHT: number;
  accesoriesHT: number;
  deliveryPackageHT: number;
  optionsTTC: number;
  accesoriesTTC: number;
  deliveryPackageTTC: number;
  tireCountSummer: string;
  tireCountWinter: string;
  tireCountAllSeasons: string;
  insuranceAndServices?: any;
  damagesWaiver?: QuoteSchema.Schemas.MilesDamageWaiverType;
  checkMonthlyPayment?: boolean;
  monthlyPayment?: any;
  checkCashPayment?: boolean;
  withdrawalDate: number;
  totalServicesCost: number;
  distributionModel: DistributionModels;
  milesTemplateId: string;
  milesWarrantyTypeDuration?: string;
  // Benefit package
  annualDepreciationNonDeductible: number;
  fringeBenefitFuelIncluded: number;
  fringeBenefitFuelExcluded: number;
  fringeBenefitElectricCars: number;
  annualCo2Tax: number;
  annualTaxOnAirPollutants: number;
  /**
   * - Internal field. Do not overwrite.
   */
  _milesWarrantyType?: string;
}

export enum benefitPackageComponentType {
  ANNUAL_DEPRECIATION_NON_DEDUCTIBLE = '250007',
  FRINGE_BENEFIT_FUEL_INCLUDED = '250004',
  FRINGE_BENEFIT_FUEL_EXCLUDED = '250003',
  FRINGE_BENEFIT_ELECTRIC_CARS = '400006',
  ANNUAL_CO2_TAX = '400002',
  ANNUAL_TAX_ON_AIR_POLLUTANTS = '400004',
}
